export const MAX_WIDTH_MOBILE_SCREEN = 768;
